import type { ForNodeType } from "@/components/features/_model/types/auto-generator-for-view-model";

import { SwitchField } from "@/components/ui/form/fields/switch-field";

type Props = {
	isSCConnected: ForNodeType<boolean | null | undefined>;
	onToggle: (checked: boolean | undefined) => void;
};

export const ScConnectedToggle = ({ isSCConnected, onToggle }: Props) => {
	return (
		<SwitchField
			label="サイトコントローラーと連携する"
			value={Boolean(isSCConnected.value)}
			handleInput={onToggle}
		/>
	);
};

ScConnectedToggle.displayName = "ScConnectedToggle";
